import { render } from "./Statistique.vue?vue&type=template&id=3dad2e06&scoped=true"
import script from "./Statistique.vue?vue&type=script&lang=js"
export * from "./Statistique.vue?vue&type=script&lang=js"

import "./Statistique.vue?vue&type=style&index=0&id=3dad2e06&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dad2e06"]])

export default __exports__